import { Model } from 'modules/core/lib/mobx-rest'

interface A3nomConfigAttributes {
  id: number
  autonumbering_starts_on: number
  code_prefix: string
  company_id: number
}

class A3nomConfig extends Model<A3nomConfigAttributes> {
  static urlRoot() {
    return '/payroll_integrations/a3nom/configs'
  }
}

export default A3nomConfig
